

















































































































































































































































































































































































import { Component, Ref, Vue } from "vue-property-decorator";
import { InspectionFormCollection } from "@/common/InspectionDataCollection";
import { VForm } from "@/common/vuetify_types";
import { CurrentActiveForm, InspectionRequest } from "@/api";
import moment from "moment";
import {
  requiredString,
  noSpace,
  requiredSelectWithZero,
  validateCharacter,
} from "@/tool/validation";
import _ from "lodash";
import { dateFormat } from "@/common/date_format";
import { selfData } from "@/common/role_utils";
import ConfirmModule from "@/components/confirmationModule/ConfirmationModule.vue";

@Component({
  components: {
    ConfirmModule,
  },
})
export default class InspectionForm extends Vue {
  @Ref("initialForm") initialForm!: VForm;
  @Ref("form") form!: VForm;

  step = 0;

  self = selfData();
  room = 0;
  formId = 0;
  date = "";
  firstNameInitial = "";
  lastnameInitial = "";
  datePicker = false;
  timePicker = false;
  submitting = false;
  confirmClose = false;
  minDate = moment()
    .local()
    .format("YYYY-MM-DD");
  textRules = [requiredString, noSpace];
  selectRules = [requiredSelectWithZero];
  charRules = [validateCharacter];
  commentError = "";
  feedbackError = "";
  meetError = "";
  ratingError = "";
  isSkip = false;

  inspectionData: InspectionFormCollection[] = [];
  inspectionReq: InspectionRequest = {
    inspection: {
      companyId: 0,
      formId: 0,
      bedId: 0,
      roomId: 0,
      inspectedBy: 0,
      submittedDate: "",
      submittedTime: "",
    },
    patient: {
      companyId: 0,
      roomId: 0,
      name: "",
    },
    data: [],
  };

  async created() {
    await this.$store.dispatch("inspection/fetchGuardianRooms");
  }

  get companyRooms() {
    return this.$store.getters["inspection/guardianRooms"] || [];
  }

  get questionLists() {
    const form = this.$store.getters[
      "inspection/activeForm"
    ] as CurrentActiveForm;
    this.formId = form.id;
    let index = 1;
    this.inspectionData = [];
    _.sortBy(form?.questions || [], ["order"], ["desc"]);
    _.forEach(form?.questions || [], question => {
      const data = {
        index: index,
        question: question,
        data: {
          questionId: question.id,
          comment: undefined,
          feedback: undefined,
          ratingScore: 0,
          meet: undefined,
          skipQuestion: false,
        },
      };
      this.inspectionData.push(JSON.parse(JSON.stringify(data)));
      index++;
    });
    return this.inspectionData;
  }

  selectFloor() {
    this.$store.dispatch("inspection/fetchGuardianBeds", this.room);
  }

  get roomBeds() {
    return this.$store.getters["inspection/guardianBeds"] || [];
  }

  formatDate(date: string) {
    this.inspectionReq.inspection.submittedDate = dateFormat(date);
  }

  nextInspection() {
    this.isSkip = false;
    const firstNameValid = validateCharacter(this.firstNameInitial);
    const lastNameValid = validateCharacter(this.lastnameInitial);

    const validName = firstNameValid && lastNameValid;
    const valid = this.initialForm.validate();
    if (valid && validName) {
      this.inspectionReq.inspection.companyId = this.self.companyId;
      this.inspectionReq.inspection.formId = this.formId;
      this.inspectionReq.inspection.inspectedBy = this.self.id;
      this.inspectionReq.inspection.roomId = this.room;
      this.inspectionReq.patient.companyId = this.self.companyId;
      this.inspectionReq.patient.roomId = this.room;
      this.step++;
    }
  }

  clearError() {
    this.commentError = "";
    this.feedbackError = "";
    this.meetError = "";
    this.ratingError = "";
  }

  validate(item: InspectionFormCollection): boolean {
    this.clearError();
    let valid = true;
    if (!item.question.ratingScore) {
      if (item.data.meet == undefined && !item.data.skipQuestion) {
        this.meetError = "Required";
        valid = false;
      }
    } else {
      if (!item.data.skipQuestion && !item.data.ratingScore) {
        this.meetError = "Give 1-5 rating or select checkbox for skip.";
        valid = false;
      }
    }

    return valid;
  }

  next(item: InspectionFormCollection) {
    const valid = this.validate(item);
    if (valid) this.step++;
  }

  async submit(item: InspectionFormCollection) {
    const valid = this.validate(item);
    if (valid) {
      this.submitting = !this.submitting;
      this.inspectionReq.patient.name =
        this.firstNameInitial.toUpperCase() +
        " " +
        this.lastnameInitial.toUpperCase();
      this.inspectionReq.data = [];
      _.forEach(this.inspectionData, item => {
        if (item?.data.skipQuestion) {
          item.data.ratingScore = 0;
          item.data.meet = undefined;
        }
        this.inspectionReq.data.push({
          id: item.data.id,
          inspectionId: item.data.inspectionId,
          questionId: item.data.questionId,
          comment: item.data.comment,
          feedback: item.data.feedback,
          ratingScore: item.data.ratingScore,
          meet: item.data.meet,
          skipQuestion: item.data.skipQuestion,
        });
      });
      await this.$store.dispatch(
        "inspection/addInspection",
        this.inspectionReq,
      );
      this.submitting = !this.submitting;
      this.step++;
    }
  }

  close() {
    this.$emit("close");
  }

  recognize() {
    this.$emit("recognize");
  }

  async skipInspection() {
    this.isSkip = true;
    const valid = this.initialForm.validate();
    if (valid) {
      this.inspectionReq.inspection.companyId = this.self.companyId;
      this.inspectionReq.inspection.formId = this.formId;
      this.inspectionReq.inspection.inspectedBy = this.self.id;
      this.inspectionReq.inspection.roomId = this.room;
      this.inspectionReq.patient.companyId = this.self.companyId;
      this.inspectionReq.patient.roomId = this.room;
      await this.$store.dispatch(
        "inspection/skipInspection",
        this.inspectionReq.inspection,
      );
      this.$emit("close");
    }
    this.isSkip = false;
  }
}
